(() => {
  const mounted = new WeakSet();

  function mount(section) {
    if (mounted.has(section)) return;
    mounted.add(section);
    const cards = [...section.querySelectorAll('[data-quest-card]')];
    const filters = [...section.querySelectorAll('[data-quest-filter]')];
    const free = section.querySelector('[data-quest-free]');
    const count = section.querySelector('[data-quest-count]');
    const dialog = section.querySelector('[data-quest-dialog]');
    const body = section.querySelector('[data-quest-dialog-body]');
    let category = 'all';
    let opener = null;
    let previousOverflow = null;

    function updateMonths() {
      const month = new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', {
        timeZone: 'Europe/London', month: 'long', year: 'numeric'
      }).format(new Date());
      section.querySelectorAll('[data-quest-month]').forEach(element => {
        const label = element.hasAttribute('data-month-uppercase') ? month.toLocaleUpperCase() : month;
        element.textContent = element.dataset.monthTemplate ? element.dataset.monthTemplate.replace('__MONTH__', label) : label;
      });
    }

    function applyFilters() {
      let visible = 0;
      cards.forEach(card => {
        const show = (category === 'all' || card.dataset.category === category) && (!free.checked || card.dataset.free === 'true');
        card.hidden = !show;
        if (show) visible += 1;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.questFilter === category)));
      count.textContent = count.dataset.countTemplate.replace('__COUNT__', String(visible));
    }

    function closeDialog() {
      if (!dialog.open) return;
      if (window.MSDialogs?.close) window.MSDialogs.close(dialog);
      else dialog.close();
    }

    filters.forEach(button => button.addEventListener('click', () => {
      category = button.dataset.questFilter;
      applyFilters();
    }));
    free.addEventListener('change', applyFilters);
    section.querySelector('[data-quest-tools]').hidden = false;
    updateMonths();

    if (typeof dialog.showModal !== 'function') return;
    section.querySelectorAll('[data-quest-open]').forEach(trigger => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', event => {
        event.preventDefault();
        const detail = trigger.closest('[data-quest-details]').querySelector('[data-quest-detail]');
        body.replaceChildren(...[...detail.children].map(element => element.cloneNode(true)));
        body.querySelector('[data-quest-detail-title]').id = dialog.getAttribute('aria-labelledby');
        opener = trigger;
        if (window.MSDialogs?.open) window.MSDialogs.open(dialog);
        else {
          previousOverflow = document.documentElement.style.overflow;
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
        dialog.scrollTop = 0;
      });
    });
    dialog.querySelector('[data-quest-close]').addEventListener('click', closeDialog);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog();
    });
    dialog.addEventListener('close', () => {
      if (previousOverflow !== null) {
        document.documentElement.style.overflow = previousOverflow;
        previousOverflow = null;
      }
      if (opener?.isConnected) opener.focus({preventScroll:true});
      body.replaceChildren();
    });
  }

  function boot(root = document) {
    if (root.matches?.('[data-quests-section]')) mount(root);
    root.querySelectorAll('[data-quests-section]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), {once:true});
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-quest-dialog][open]').forEach(dialog => {
      if (window.MSDialogs?.close) window.MSDialogs.close(dialog);
      else dialog.close();
    });
  });
})();
